<template>
  <fh-container>
    <v-card-title>Importar lista productos Senave</v-card-title>
    <v-row>
      <v-col sm="5">
        <v-form
          ref="fileForm"
          v-model="validFile"
          @submit.prevent="handleImportFile"
          class="mt-2"
        >
          <v-file-input
            v-model="file"
            :rules="fileRules"
            label="Subir planilla Senave"
            accept=".xlsx"
            truncate-length="50"
            ref="file"
            outlined
          >
            <template v-slot:append>
              <v-btn
                @click="$refs.file.$refs.input.click()"
                class="text-none mt-n2"
                depressed
              >
                Buscar
              </v-btn>
            </template>
          </v-file-input>

          <div class="text-center mt-2">
            <span v-show="message" class="green--text">{{ message }}</span>
          </div>

          <v-row class="justify-space-around mt-3">
            <v-btn
              :disabled="importando"
              :loading="importando"
              @click="handleImportFile"
              class="text-none"
              depressed
            >
              Importar
            </v-btn>
            <v-btn
              :disabled="listaImportadaProductos.length === 0"
              :loading="actualizando"
              @click="handleActualizarLista"
              class="text-none secondary"
              depressed
            >
              Actualizar
            </v-btn>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </fh-container>
</template>

<script>
import { mapActions } from "vuex";
import FhContainer from "@/components/FhContainer";
import FhCard from "@/components/FhCard";
import { read, utils } from "xlsx";
import ValoresRepository from "@/services/ValoresRepository";

export default {
  name: "AdminConfiguraciones",
  components: { FhCard, FhContainer },
  data() {
    return {
      validFile: false,
      // Defer validation until first submit attempt
      isSubmitFile: false,
      file: null,
      importando: false,
      actualizando: false,
      listaImportadaProductos: [],
      message: null,
      fileRules: [(v) => !this.isSubmitFile || !!v || "Planilla requerida"],
    };
  },
  computed: {},
  methods: {
    ...mapActions("productos", ["fetchListaProductoAgricultor"]),
    handleImportFile() {
      this.isSubmitFile = true;

      if (!this.$refs.fileForm.validate()) {
        return;
      }
      this.importando = true;
      let reader = new FileReader();
      reader.onload = this.importFile;
      reader.readAsBinaryString(this.file);
    },
    async importFile(event) {
      let data = event.target.result;

      let wb = read(data, { type: "binary" });

      let completeExcelList = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
        header: [
          "numeroRegistro",
          "loteVenta",
          "producto",
          "registrante",
          "pActivo",
          "situacion",
          "formulacion",
          "fabricante",
          "pais",
          "resolucion",
          "habilitacion",
          "vencimiento",
          "mantenimiento",
          "uso",
          "toxicologia",
        ],
      });
      this.listaImportadaProductos = completeExcelList.reduce(
        (filterdList, producto) => {
          let situacion = producto.situacion.trimEnd();

          if (situacion !== "DEFINITIVO" && situacion !== "VIGENTE") {
            return filterdList;
          }

          let pActivo = producto.pActivo.trim();
          let productoClean = producto.producto.trim();
          filterdList.push({
            numeroRegistro: producto.numeroRegistro,
            nombre: productoClean,
            nombreRegistrante: producto.registrante.trim(),
            principioActivo: pActivo ? pActivo : productoClean,
            tipoUso: producto.uso.trim() || productoClean,
          });
          return filterdList;
        },
        []
      );

      if (this.listaImportadaProductos.length !== 0) {
        this.message =
          "Se importaron " + this.listaImportadaProductos.length + " productos";
      }
      this.importando = false;
    },
    async handleActualizarLista() {
      try {
        this.message = null;
        this.actualizando = true;
        await ValoresRepository.actualizarProductosSenave(
          this.listaImportadaProductos
        );
        this.listaImportadaProductos = [];
        this.message = "Lista de productos actualizados";
      } catch (error) {}
      this.actualizando = false;
    },
  },
};
</script>

<style>
</style>